import { entity } from "../../infra/api/rpc/api";
import { FrontDate } from "./frontDate";

export class Contract {
  public static from(from: entity.IContract): Contract {
    const createdAtDate: FrontDate = FrontDate.from(from.createdAt!);
    const updatedAtDate: FrontDate = FrontDate.from(from.updatedAt!);

    return new Contract(
      from.companyID!,
      from.projectID!,
      from.customerID!,
      from.gsFileURL || "",
      from.signedFileURL || "",
      from.title || "",
      from.description || "",
      from.meetingNum || 0,
      from.meetingInterval!,
      from.meetingMinutes || 0,
      from.workingHour || 0,
      from.workingInterval!,
      from.feePerMonth || 0,
      from.contractType!,
      from.startFromYM || "",
      from.endToYM || "",
      from.requester!,
      from.isApproved || false,
      createdAtDate,
      updatedAtDate
    );
  }

  constructor(
    public readonly companyID: string,
    public readonly projectID: string,
    public readonly customerID: string,
    public readonly gsFileURL: string,
    public readonly signedFileURL: string,
    public readonly title: string,
    public readonly description: string,
    public readonly meetingNum: number,
    public readonly meetingInterval: entity.Contract.Interval,
    public readonly meetingMinutes: number,
    public readonly workingHour: number,
    public readonly workingInterval: entity.Contract.Interval,
    public readonly feePerMonth: number,
    public readonly contractType: entity.Contract.Type,
    public readonly startFromYM: string,
    public readonly endToYM: string,
    public readonly requester: entity.Contract.Requester,
    public readonly isApproved: boolean,
    public readonly createdAt: FrontDate,
    public readonly updatedAt: FrontDate
  ) {}

  public id = (): string => {
    return `${this.projectID}-${this.companyID}-${this.customerID}`;
  };

  public getCreatedAtString = (): string => {
    // YYYY-MM-DD
    return `${this.createdAt.year}-${this.createdAt.month}-${this.createdAt.day}`;
  };

  public hasMeetingInfo = (): boolean => {
    return this.meetingNum > 0;
  };

  public hasWorkingInfo = (): boolean => {
    return this.workingHour > 0;
  };

  public statusStr = (): string => {
    if (this.requester === entity.Contract.Requester.Requester_Admin) {
      return "Adminから報告済";
    }

    if (this.isApproved) {
      return "承認済み";
    }

    switch (this.requester) {
      case entity.Contract.Requester.Requester_Company:
        return "承認待ち";
      case entity.Contract.Requester.Requester_Customer:
        return "承認待ち";
    }

    return "";
  };

  public meetingIntervalStr = (): string => {
    switch (this.meetingInterval) {
      case entity.Contract.Interval.Interval_Month:
        return "月";
      case entity.Contract.Interval.Interval_Week:
        return "週";
    }

    return "";
  };

  public workingIntervalStr = (): string => {
    switch (this.workingInterval) {
      case entity.Contract.Interval.Interval_Month:
        return "月";
      case entity.Contract.Interval.Interval_Week:
        return "週";
    }

    return "";
  };

  public contractTypeStr = (): string => {
    switch (this.contractType) {
      case entity.Contract.Type.Type_Delegation:
        return "委任";
      case entity.Contract.Type.Type_Contract:
        return "受託";
    }

    return "その他";
  };
}



// WEBPACK FOOTER //
// ./src/domain/model/contract.ts